import _merge from 'lodash/merge';
import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../utils/style';
import {
  BORDER_RADIUS,
  STROKE_UNFOCUSED,
  STROKE_FOCUSED,
  STROKE_UNFOCUSED_COLOR,
  STROKE_FOCUSED_COLOR,
  FILL_UNFOCUSED_COLOR,
  FILL_FOCUSED_COLOR,
  TEXT_UNFOCUSED_COLOR,
  TEXT_FOCUSED_COLOR,
  SCALE_FOCUSED,
} from './button.constants';
import { getStrokeWidth } from '../../button.utils';
import { ButtonTexture } from '../../../callToAction/background/buttonTexture.component';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 40,
  [FULL_HD]: 56,
};

export const PADDING = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const ICON_WIDTH = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const ICON_PADDING_LEFT = {
  [HD]: 4,
  [FULL_HD]: 8,
};

export const getUnFocusedStyle = ({ screenSize, colorMode }) => ({
  Background: {
    color: FILL_UNFOCUSED_COLOR[colorMode],
    borderColor: STROKE_UNFOCUSED_COLOR[colorMode],
    borderWidth: getStrokeWidth(STROKE_UNFOCUSED[screenSize]),
    type: ButtonTexture,
    smooth: {
      scale: 1.0,
    },
  },
  Icon: {
    color: TEXT_UNFOCUSED_COLOR[colorMode],
  },
  Label: {
    color: TEXT_UNFOCUSED_COLOR[colorMode],
  },
});

export const getFocusedStyle = ({ screenSize, colorMode }) => ({
  Background: {
    color: FILL_FOCUSED_COLOR[colorMode],
    borderColor: STROKE_FOCUSED_COLOR[colorMode],
    borderWidth: getStrokeWidth(STROKE_FOCUSED[screenSize]),
    smooth: {
      scale: SCALE_FOCUSED,
    },
  },
  Icon: {
    color: TEXT_FOCUSED_COLOR[colorMode],
  },
  Label: {
    color: TEXT_FOCUSED_COLOR[colorMode],
  },
});

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const h = HEIGHT[screenSize];
  const font = getFont(FONT.OTTAWA_2, screenSize);

  return _merge(
    {
      h,
      Background: {
        h,
        color: FILL_UNFOCUSED_COLOR[colorMode],
        borderRadius: BORDER_RADIUS[screenSize],
      },
      Icon: {
        y: Math.round((h - ICON_HEIGHT[screenSize]) / 2),
      },
      Label: {
        y: Math.round((h - font.lineHeight) / 2),
        text: {
          ...font,
          verticalAlign: 'middle',
        },
      },
    },
    getUnFocusedStyle(context),
  );
};
